<section>
  <h4>Unpaid Invoice List</h4>
  <kendo-card width="100%">
    <div class="content-wrapper">
      <app-bookkeeping-sage-invoice-filters (applyFilter)="changeFilters($event)"
        (clearFilter)="changeFilters($event)"></app-bookkeeping-sage-invoice-filters>
      <kendo-grid class="evidence-list" [data]="{
        data: (dataSource?.contents$ | async) || [],
        total: (dataSource?.pageInfo$ | async)?.totalCount
      }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
        buttonCount: 6,
        type: 'numeric',
        pageSizes: [5, 10, 25, 100],
        previousNext: true,
        responsive: true,
        position: 'bottom'
      }" (pageChange)="pageOptions?.paginate($event)" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)"
        [navigatable]="false">

        <kendo-grid-column [field]="orderByOptions.CustomerName" title="Customer" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.customerName || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.InvoiceDate" title="Date" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.invoiceDate || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.CustomerEmail" title="Email" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.customerEmail || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.InvoiceNumber" title="Invoice Number" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.invoiceNumber || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.DueDate" title="Due Date" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.dueDate || "-" }}
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [field]="orderByOptions.TotalAmountDue" title="Open Balance" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem?.totalTxnAmountDue || "-" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [field]="orderByOptions.DueInDays" title="Ageing" [width]="8" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ +dataItem?.dueInDays || "-" }}
          </ng-template>
        </kendo-grid-column>

        <ng-template #noValue>
          <p class="kendo-caption-body">-</p>
        </ng-template>
      </kendo-grid>
    </div>
  </kendo-card>
</section>
